import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { blackListWords } from "../../config/black_list_words";
import * as _ from "lodash";
// import { injectIntl } from 'react-intl';
import { multiIncludes } from "../../utils/common-utils";
const ENTER_KEY = 13;

class Inputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputTouched: false,
      inputValid: false,
      value: "",
      focused: false,
      cardType: ""
    };
    this.regex = {
      //name: /^[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð',.\- ]+$/,
      name: /^[0-9a-zA-Z$";'@$!%*?&.+-/ /]+$/,
      utf8: /^[0-9a-zA-Z$";'@$!%*?&.+-/ /]+$/,
      userName: /^[A-Za-z0-9]{3,30}(?:[_-][A-Za-z0-9]+)*$/,
      companyName: /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!][A-Za-z0-9_.]{2,}[a-zA-Z0-9_ ]*$/,
      phone: /^\d{6,}(?:,(?:\+\d{2})?\d{6,})*$/,
      address: /^.[^&]{2,29}$/,
      social: /(https?:\/\/[^\s]+)/,
      ssn: /^([0-9]){3}(([ ]|[-])?([0-9]){2})(([ ]|[-])?([0-9]){4})?$/,
      domain: /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
      zip: {
        US: /^\d{5}(?:[-\s]\d{4})?$/,
        CA: /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/,
        AU: /^\d{4}(?:[-\s]\d{4})?$/,
        GB: /[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}/,
        ALL: /^([a-zA-Z0-9_-]){1,8}$/
      },
      cvc: /^\d{3,4}$/,
      password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/,
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      bgUpload: /^(([a-zA-Z]:)|(\\{2}\w+)\$?)(\\(\w[\w].*))+(.jpg|.jpeg)$/
    };
  }

  componentWillMount() {
    if (this.props.value) {
      let state = _.extend({}, this.state);
      state.inputTouched = true;
      state.inputValid = true;
      state.value = this.props.value;
      this.setState(state);
    }
  }

  shouldComponentUpdate(nextProps) {
    const { verifyResponse, value, disabled, type } = nextProps;
    if (disabled !== this.props.disabled) {
      return true;
    }
    if (verifyResponse) {
      return true;
    }
    if (nextProps.password || value !== this.state.value) {
      return true;
    }
    return true;
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.value !== this.props.value ||
      (nextProps.countryType !== this.props.countryType && this.props.value)
    ) {
      this.setState({ value: nextProps.value }, () => {
        this.validateField(nextProps.value, nextProps.countryType);
      });
    }
    if (nextProps.email !== this.props.email && nextProps.value) {
      this.nextEmailVal = nextProps.email;
      const valid = this.validateField(nextProps.value);
      this.props.onChange(this.props.value, valid);
    }
    if (nextProps.password !== this.props.password && nextProps.value) {
      this.nextPasswordVal = nextProps.password;
      const valid = this.validateField(nextProps.value);
      this.props.onChange(this.props.value, valid);
    }
  }

  onCheckExistIcon = (type, valid) => {
    const { verifyResponse } = this.props;
    if (
      !verifyResponse ||
      !valid ||
      !this.regex[type].test(this.props.value) ||
      this.props.oldValue === this.props.value
    )
      return "";
    let iconClassName = "";
    if (verifyResponse.isPending) {
      iconClassName = "fa fa-spinner fa-spin fa-3x fa-fw";
    } else if (verifyResponse.status === 409) {
      iconClassName = "fa fa-times fail";
    } else if (verifyResponse.status === 200) {
      iconClassName = "fa fa-check success";
    }
    return (
      <i
        className={`input-right-icon ${iconClassName}`}
        style={this.props.iconStyle}
      />
    );
  };

  validateField(item, countryType) {
    let state = true;
    const value = item;
    const currentYear = new Date().getFullYear();
    const { type, required, oldPassword, errorMessage, fileType } = this.props;
    const regex = this.regex;
    let badWordsContain;
    if (required) {
      if (type === "name" || type === "lastName") {
        state = regex.name.test(value);
      } else if (type === "login") {
        state = regex.utf8.test(value);
      } else if (type === "city") {
        state = regex.name.test(value);
      } else if (type === "BDay") {
        state = value > 1 && value <= 31;
      } else if (type === "BYear") {
        state = value <= currentYear && value > currentYear - 120;
      } else if (type === "countryState") {
        state = value.trim() ? true : false;
        state = this.props.sameAddress ? true : state;
      } else if (type === "phone") {
        state = value ? regex.phone.test(value) : true;
      } else if (type === "upload") {
        let type_array = value.type.split("/");
        let type = type_array[type_array.length - 1];
        state = fileType.includes(type);
      } else if (type === "CCNumber") {
        let valueLength = value ? value.length : 0;
        state = valueLength >= 15;
      } else if (type === "CHName") {
        state = regex.name.test(value);
      } else if (type === "social") {
        state = regex.social.test(value) || (value && !value.trim());
      } else if (type === "ssn") {
        state = value ? regex.ssn.test(value) : true;
      } else if (type === "cvc") {
        state = regex.cvc.test(value);
      } else if (type === "postalCode") {
        state = regex.zip[countryType]
          ? regex.zip[countryType].test(value.toUpperCase())
          : regex.zip["ALL"].test(value.toUpperCase());
        state = this.props.sameAddress ? true : state;
      } else if (type === "address") {
        state = regex.address.test(value);
        state = this.props.sameAddress ? true : state;
      } else if (type === "email") {
        const email = value.toLowerCase();
        // _.each(blackListWords, function(value) {
        //   email.includes(value) ? (badWordsContain = true) : null;
        // });
        let emailspilt = email.split("@");
        state =
          regex.email.test(value) &&
          !email.includes("geraldine", "aquino") &&
          !email.includes("geraldine", "borromeo") &&
          !email.includes("atif", "kamran") &&
          (emailspilt[1] === "gmail.com" || !email.includes("+")) &&
          !badWordsContain;
        this.errorMessage = state ? "" : "Invalid Email";
      } else if (type === "confirm_email") {
        const email = this.nextEmailVal || this.props.email;
        state = email === value;
      } else if (type === "domain") {
        state = value.trim()
          ? regex[type].test(value) &&
            !multiIncludes(value, ["www", "http", "https", "mytravelbiz"]) &&
            value.split(".").length === 2
          : true;
        //debugger
      } else if (type === "userName") {
        state = regex.userName.test(value); // && (this.props.existResponse && this.props.existResponse.status)
      } else if (type === "profileUserName") {
        state = regex.userName.test(value);
      }else if (type === "name") {
        state = value ? regex.name.test(value) : true;
      }
      this.errorMessage = state ? "" : "Invalid Field";
      this.errorMessage = badWordsContain ? "Invalid Field" : "Invalid Field";
    } else {
      if (type === "repeatPassword") {
        let password = this.nextPasswordVal || this.props.password;

        state = value ? password === value : true;
        this.errorMessage = state ? "" : "Invalid Field";
      }
      //this.errorMessage = state ? "" : "Invalid Field";
      // state = true;
    }
    // check for utf8 charackters
    if (type !== "CCNumber") {
      if (state && value) {
        state = this.regex.utf8.test(value);
      }
      this.errorMessage = state ? "" : "Invalid Field" || "Invalid Field";
    }
    if (type === "password") {
      state = value
        ? regex.password.test(value) && oldPassword !== value
        : true;
      this.errorMessage = state ? "" : '';

    }

    return state;
  }

  getCardType(number) {
    let re = new RegExp("^4");
    if (number.match(re) != null) return "visa";

    re = new RegExp("^(34|37)");
    if (number.match(re) != null) return "americanExpress";

    re = new RegExp("^5[1-5]");
    if (number.match(re) != null) return "masterCard";

    re = new RegExp("^6011");
    if (number.match(re) != null) return "discover";

    re = new RegExp("^(2131|1800|35)");
    if (number.match(re) != null) return "jcb";

    re = new RegExp("^(300|305|36|38)");
    if (number.match(re) != null) return "dinersClub";

    return "";
  }

  checkField(event, type, country) {
    const { verifyType, verifyOnExist, oldValue } = this.props;
    let value;
    if (type === "upload") {
      value = event.target.files[0];
    } else {
      value = typeof event === "object" ? event.target.value : event;
    }
    if (type === "CCNumber") {
      const cardValueType = this.getCardType(value);
      this.state.cardType = cardValueType;
    }
    const valid = this.validateField(value, country);

    if (verifyType && oldValue !== value && valid) {
      verifyOnExist ? verifyOnExist(verifyType, value) : null;
    }

    this.setState(
      { value, inputValid: valid },
      this.props.onChange(value, valid)
    );
  }

  render() {
    // console.log(this.errorMessage)
    const inputClass = "form-control  " + this.props.inputClassName;
    const inlineStyle = this.props.style;
    const {
      type,
      placeholder,
      disabled,
      verifyType,
      containerStyle
    } = this.props;
    return (
      <div className="input-box">
        {type === "name" && (
          <input
            type="text"
            className={inputClass}
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
            disabled={disabled}
            onKeyPress={e => {
              e.key == "Enter" && this.props.onKeyPress();
            }}
          />
        )}
        {type === "search" && (
          <input
            type="text"
            className={inputClass}
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
            disabled={disabled}
          />
        )}
        {type === "password" && (
          <input
            type="password"
            className={inputClass}
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
          />
        )}
        {this.props.type === "confirm_password" && (
          <input
            type="password"
            id="txtConfirmPassword"
            name={this.props.name}
            className="form-control single"
            onChange={e => {
              this.checkField(e, this.props.type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
            autoComplete="off"
          />
        )}
        {type === "address" && (
          <input
            type="text"
            className={inputClass}
            maxLength="30"
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
          />
        )}
        {type === "city" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "countryState" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "postalCode" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type, this.props.countryType);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "social" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
              style={inlineStyle || {}}
              disabled={disabled}
            />
          </div>
        )}
        {type === "CCNumber" && (
          <div ref={this.props.initCcValidator}>
            <NumberFormat
              format="#### #### #### ####"
              name="number"
              className={inputClass + " " + this.state.cardType}
              onChange={e => {
                this.checkField(e, this.props.type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "cvc" && (
          <input
            type="password"
            className={inputClass}
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
          />
        )}
        {type === "BDay" && (
          <div>
            <NumberFormat
              format="##"
              name="number"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "BYear" && (
          <div>
            <NumberFormat
              format="####"
              name="number"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
            />
          </div>
        )}
        {type === "CHName" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
              style={inlineStyle || {}}
            />
          </div>
        )}
        {type === "ssn" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={this.props.ssnLabel}
            />
          </div>
        )}
        {type === "email" && (
          <div style={containerStyle || {}}>
            <input
              type="email"
              className={inputClass}
              onBlur={e => this.props.onChangeCheckExist(e.target.value)}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              style={inlineStyle || {}}
              placeholder={placeholder || ""}
              disabled={disabled}
            />
            {this.onCheckExistIcon(type, this.state.inputValid)}
          </div>
        )}

        {type === "phone" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
              style={inlineStyle || {}}
              disabled={disabled}
            />
          </div>
        )}

        {type === "mid_init" && (
          <input
            type="text"
            className="form-control middlereg"
            onChange={e => {
              this.checkField(e, this.props.type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
            maxLength="1"
          />
        )}
        {type === "userName" && (
          <div>
            <input
              type="text"
              className={inputClass}
              onPaste={e =>
                this.props.verifyOnExist(type, e.clipboardData.getData("Text"))
              }
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              style={inlineStyle || {}}
              placeholder={this.props.placeholder || ""}
              disabled={disabled}
            />
            {this.onCheckExistIcon(type, this.state.inputValid)}
          </div>
        )}
        {type === "domain" && (
          <div style={containerStyle || {}}>
            <input
              type="url"
              className={inputClass}
              onChange={e => {
                this.checkField(e, type);
              }}
              value={this.state.value}
              placeholder={placeholder || ""}
              style={inlineStyle || {}}
              disabled={disabled}
            />
          </div>
        )}

        {type === "login" && (
          <input
            type="text"
            className={inputClass}
            onChange={e => {
              this.checkField(e, type);
            }}
            value={this.state.value}
            placeholder={placeholder || ""}
            disabled={disabled}
          />
        )}

        {this.errorMessage && (
          <div className="error-text">{this.errorMessage}</div>
        )}
        {this.props.verifyResponse &&
          !this.props.verifyResponse.isPending &&
          this.props.verifyResponse.status === 409 && (
            <div className="error-text">
              {this.props.verifyResponse.message}
            </div>
          )}
      </div>
    );
  }
}

export default Inputs;



// WEBPACK FOOTER //
// ./src/shared/FormComponents/Inputs.jsx